import  gql  from 'graphql-tag'

export const SHARE_ANALYSIS_FTP = gql`mutation shareCharacterAnalysisByFtp($input: ShareCharacterAnalysisBySFTPMutationInput!){
    shareCharacterAnalysisByFtp(input: $input){
        errors{
            field
            messages
        }
    }
}`;